import React, { Component, PropTypes } from 'react';
import { Units, Colors } from 'Css';
import classNames from 'classnames';
import FormFieldContainer from './FormFieldContainer';

const css = oxygenCss({
  container: {
    position: 'relative',
    height: Units.keyline * 1.5,
    borderStyle: 'solid',
    borderColor: '#535353',
    backgroundColor: '#202020',
    borderWidth: 1
  },
  centerCenter: {
    left: '50%',
    top: '50%',
    marginTop: -8,
    marginLeft: -32
  },
  leftCenter: {
    left: Units.base / 2,
    top: '50%',
    marginTop: -8
  },
  rightCenter: {
    right: Units.base / 2,
    top: '50%',
    marginTop: -8
  },
  topLeft: {
    left: Units.base / 2,
    top: Units.base / 2
  },
  topCenter: {
    left: '50%',
    top: Units.base / 2,
    marginLeft: -32
  },
  topRight: {
    right: Units.base / 2,
    top: Units.base / 2
  },
  bottomLeft: {
    left: Units.base / 2,
    bottom: Units.base / 2
  },
  bottomCenter: {
    left: '50%',
    bottom: Units.base / 2,
    marginLeft: -32
  },
  bottomRight: {
    right: Units.base / 2,
    bottom: Units.base / 2
  },
  position: {
    position: 'absolute',
    cursor: 'pointer',
    width: 64,
    height: 16,
    borderStyle: 'solid',
    boxSizing: 'border-box',
    borderWidth: 1,
    borderColor: '#535353',
    ':hover': {
      backgroundColor: 'rgba(127, 127, 127, 0.5)'
    },
    '&selected': {
      borderColor: Colors.creen
    }
  }
});

class PositionChooser extends Component {
  static propTypes = {
    selected: PropTypes.string,
    title: PropTypes.string,
    onChange: PropTypes.func,
    positions: PropTypes.array
  };

  static defaultProps = {
    positions: [
      'centerCenter',
      'leftCenter',
      'rightCenter',
      'topLeft',
      'topCenter',
      'topRight',
      'bottomLeft',
      'bottomCenter',
      'bottomRight'
    ],
    selected: 'centerCenter'
  };

  handleTouchTap = position => {
    const { onChange, selected } = this.props;
    if (position !== selected && onChange) {
      onChange(position);
    }
  };

  render() {
    const { title, selected, positions } = this.props;
    return (
      <FormFieldContainer title={title}>
        <div className={css.container}>
          {positions.map(position => {
            const classes = classNames(css.position, css[position], {
              [css.selected]: position === selected
            });
            return (
              <div
                key={position}
                className={classes}
                onTouchTap={this.handleTouchTap.bind(this, position)}
              />
            );
          })}
        </div>
      </FormFieldContainer>
    );
  }
}

export default PositionChooser;



// WEBPACK FOOTER //
// ./src/js/components/Store/Editor/PositionChooser.js